(function () {
    'use strict';

    angular.module('GroupList')
      .controller('GroupListController',
        ['$rootScope', '$scope', '$filter', 'GroupListService', '$location',
        'URLS', 'URL_PARAMS', 'TenantListService', 'GroupExternalListService',
        'GroupListPaging', 'toastr', 'EventHandlerService', '$window', '$routeParams',
        'GroupListPOSTPaging', "GroupFilterModel", '$timeout', 'IdpProviderService',
        function (
          $rootScope, $scope, $filter, GroupListService, $location,
          URLS, URL_PARAMS, TenantListService, GroupExternalListService,
          GroupListPaging, toastr, EventHandlerService, $window, $routeParams,
          GroupListPOSTPaging, GroupFilterModel, $timeout, IdpProviderService) {

      $scope.orderByText = 'Name';
      $scope.groupListService = GroupListService;
      $scope.helpCaption = 'HelpGroupsPage';
      $scope.searchInputPlaceholderText = "SearchGroupByNameAndDescription";

      $scope.remoteQueueManagementCalibrationObject = {
        searchInputPlaceholderText: "SearchGroupByNameAndDescription"
      };
      $scope.eventHandlerService = EventHandlerService;

      $scope.windowWidth = $window.innerWidth;
      $scope.loadingPage = true;
      let initialListRequest = true;

      $scope.groupListPostPaging = new GroupListPOSTPaging();
      $scope.requestType = 'POST';
      $scope.filtersList = new GroupFilterModel('GROUP_LIST_VIEW').filters;

      $scope.hasLegacyEnabledDirectory = TenantListService.currentTenant
        ? IdpProviderService
          .allDirectories(TenantListService.currentTenant)
          .some(function (d) { return d.groupSyncState === 'LEGACY_ENABLED'; })
        : false;

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      (function(){
        initEventHandler();
        readRoutePageParam();
      })();

      function readRoutePageParam () {
        $scope.groupListPostPaging.pagingCriteria.page = $routeParams['groupPage'] > 0 ? $routeParams['groupPage'] -1 : 0;
      }

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

      function reportWindowSize() {
        $scope.windowWidth = $window.innerWidth;
        $scope.$apply();
      }
      $window.onresize = reportWindowSize;

      function getGroupListPaged () {
        $scope.loadingPage = true;
        GroupListService.getGroupListPagedByPost($scope.groupListPostPaging).then(function(groupContainer) {

          if (initialListRequest || $scope.groupListPostPaging.pagingCriteria.page === 0) {
            initialListRequest = false;
            $location.path($location.path(), false).search({ groupPage: parseInt($scope.groupListPostPaging.pagingCriteria.page) + 1 }).replace();
          } else {
            $location.path($location.path(), false).search({ groupPage: parseInt($scope.groupListPostPaging.pagingCriteria.page) + 1 })
          }

          $scope.groupContainer = groupContainer;
            $scope.loadingPage = false;
          }).catch(function() {
            $scope.loadingPage = false;
          })
      };

      $scope.getGroupListPaged = function () {
        getGroupListPaged();
      }

      $scope.textSearch = function () {
        getGroupListPaged();
      }


      $scope.getNextPage = function(showPrevious) {
        if (showPrevious) {
          if ($scope.groupListPostPaging.pagingCriteria.page > 0) {
            $scope.groupListPostPaging.pagingCriteria.page--;
          }
        } else {
          if ($scope.groupListPostPaging.pagingCriteria.page + 1 < $scope.groupContainer.page.totalPages) {
            $scope.groupListPostPaging.pagingCriteria.page++;
          }
        }
        getGroupListPaged();
      }

      $scope.synchronizeGroups = function (event) {
        $timeout(function () {
          $scope.selectedContextMenuItem = {
            type: 'groupSyncPicker',
            title: 'SynchronizeGroups',
            bypassCloseOutside: false
          };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.dialogContext = {
            name: 'SynchronizeGroups',
            title: 'SynchronizeGroups',
            dontUseName: true,
            dontUseTitle: false
          };
          $scope.dialogResource = {
            tenant: TenantListService.currentTenant,
            directories: IdpProviderService
              .allDirectories(TenantListService.currentTenant)
              .filter(function (d) { return d.groupSyncState === 'LEGACY_ENABLED'; })
          };
        }, 50);
      };

      $scope.closeSyncDialog = function () {
        $scope.selectedContextMenuItem = null;
        $scope.contextPosition = null;
        $scope.dialogContext = null;
        $scope.dialogResource = null;
      };

      $scope.$watch(function(){
        return $rootScope.synchronizingGroupsIsOngoing;
      }, function(){
        if (!$rootScope.synchronizingGroupsIsOngoing) {
          $scope.ongoingGroupSync = false;
          getGroupListPaged();
        } else {
          $scope.ongoingGroupSync = true;
        }
      }, true);


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        $scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context);
              break;
            }
          } else {
            $scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {
          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: title,
            type: 'statement',
          }
          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }


        $scope.clearTooltip = function () {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        $scope.openListMenu = function (event, group) {
          const position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            $scope.closeListMenu();
            $scope.listMenuContext = group;
            $scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'groupList',
              scrollContainerId: 'GroupScrollContainer'
            }
            $scope.$apply();
          }, 50)
        }

        $scope.closeListMenu = function (group, action) {
          $scope.listMenuContext = null;
          $scope.listMeta = null;

        }

    }]);
})();
